import { editorialPhotos } from '@/lib/editorial-imagery';

export const sitePhotos = {
  hero: {
    file: '01-hero',
    alt: 'Bright clinical room with a hospital bed, ultrasound cart and patient monitor.',
    caption: 'Illustrative clinical setting',
  },
  'medical-equipment': {
    file: '02-medical-equipment',
    alt: 'Ultrasound equipment and a patient monitor in a bright clinical room.',
    caption: 'Illustrative medical equipment',
  },
  'laboratory-equipment': {
    file: '03-laboratory',
    alt: 'Laboratory professional handling capped specimen tubes beside a microscope and analyzer.',
    caption: 'Illustrative laboratory workflow',
  },
  consumables: {
    file: '04-consumables',
    alt: 'Packaged syringes, gauze, specimen tubes and disposable gloves on a clean worktop.',
    caption: 'Illustrative clinical supplies',
  },
  'procurement-consultancy': {
    file: '06-procurement-consultancy',
    alt: 'Healthcare professionals reviewing an equipment brochure and a facility floor plan.',
    caption: 'Illustrative equipment planning',
  },
  'user-training': {
    file: '07-user-training',
    alt: 'Engineer demonstrating an inactive patient monitor to two clinical staff members.',
    caption: 'Illustrative operator training',
  },
  'delivery-support': {
    file: '08-delivery-support',
    alt: 'Logistics professional checking equipment cartons in a clean storage area.',
    caption: 'Illustrative equipment delivery support',
  },
  ...editorialPhotos,
} as const;

export type SitePhotoKey = keyof typeof sitePhotos;

export const detailPhotos: Record<string, SitePhotoKey> = {
  'medical-equipment': 'detail-medical',
  'laboratory-equipment': 'laboratory-equipment',
  consumables: 'detail-consumables',
  'installation-commissioning': 'detail-installation',
  'maintenance-calibration': 'detail-maintenance',
  'biomedical-engineering': 'detail-engineering',
  'procurement-consultancy': 'detail-procurement',
};

// Assign each editorial photograph to one placement instead of sharing a detail image.
export const solutionCardPhotos: Record<'home' | 'overview', Record<string, SitePhotoKey>> = {
  home: {
    'medical-equipment': 'medical-equipment',
    'laboratory-equipment': 'home-laboratory',
    consumables: 'consumables',
  },
  overview: {
    'medical-equipment': 'overview-medical',
    'laboratory-equipment': 'overview-laboratory',
    consumables: 'overview-consumables',
  },
};

export const serviceCardPhotos: Record<string, SitePhotoKey> = {
  'installation-commissioning': 'user-training',
  'maintenance-calibration': 'service-maintenance-card',
  'biomedical-engineering': 'service-engineering-card',
  'procurement-consultancy': 'procurement-consultancy',
};
